import api from './api';

// Laboratory API functions
export const laboratoryService = {
  // Get all laboratories
  getLaboratories: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const response = await api.get(`/laboratories${queryString ? `?${queryString}` : ''}`);
    return response.data;
  },

  // Get laboratory by ID
  getLaboratory: async (id: string) => {
    const response = await api.get(`/laboratories/${id}`);
    return response.data;
  },

  // Create new laboratory
  createLaboratory: async (laboratoryData: any) => {
    const response = await api.post('/laboratories', laboratoryData);
    return response.data;
  },

  // Update laboratory
  updateLaboratory: async (id: string, laboratoryData: any) => {
    const response = await api.put(`/laboratories/${id}`, laboratoryData);
    return response.data;
  },

  // Delete laboratory (soft delete)
  deleteLaboratory: async (id: string) => {
    const response = await api.delete(`/laboratories/${id}`);
    return response.data;
  },

  // Update laboratory rating
  updateLaboratoryRating: async (id: string, rating: number) => {
    const response = await api.put(`/laboratories/${id}/rating`, { rating });
    return response.data;
  }
};

// Supplier API functions
export const supplierService = {
  // Get all suppliers
  getSuppliers: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const response = await api.get(`/suppliers${queryString ? `?${queryString}` : ''}`);
    return response.data;
  },

  // Get supplier by ID
  getSupplier: async (id: string) => {
    const response = await api.get(`/suppliers/${id}`);
    return response.data;
  },

  // Create new supplier
  createSupplier: async (supplierData: any) => {
    const response = await api.post('/suppliers', supplierData);
    return response.data;
  },

  // Update supplier
  updateSupplier: async (id: string, supplierData: any) => {
    const response = await api.put(`/suppliers/${id}`, supplierData);
    return response.data;
  },

  // Delete supplier (soft delete)
  deleteSupplier: async (id: string) => {
    const response = await api.delete(`/suppliers/${id}`);
    return response.data;
  },

  // Update supplier rating
  updateSupplierRating: async (id: string, rating: number) => {
    const response = await api.put(`/suppliers/${id}/rating`, { rating });
    return response.data;
  },

  // Get supplier categories
  getSupplierCategories: async () => {
    const response = await api.get('/suppliers/meta/categories');
    return response.data;
  }
};